import { FC } from "react";
import { useTheme } from '../../hooks/ThemeContext';

interface AgrolendLogoProps {
    className?: string;
}


const AgrolendLogo: FC<AgrolendLogoProps> = ({ className }) => {
    const { theme } = useTheme();
    const logoSrc = theme === 'dark' ? '/logo-dark.png' : '/logo-login.png';
    return (
        <div className="flex items-center">
            <img
                src={logoSrc}
                className={`flex items-center ${className}`}
                alt="Backoffice Logo"
                width={120}
                height={51}
            />
        </div>
    );
};

export default AgrolendLogo;